import React from 'react'
import { IUseOrderGroup } from '../hooks/useOrderGroup'

export const OrderGroupContext = React.createContext<IUseOrderGroup>(null)
